// AboutPage.js
import './About.css';

import consultImg from '../assets/Home_img_Slide/Slide1 (2).jpg';
import { FaArrowDown } from "react-icons/fa";

function AboutPage() {
  return (
    <div className="about-container">

      {/* Our Story */}
      <div className="our-story">
        <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Our Story" className="story-img" />
        <div className="story-content">
          <h2>Our Story</h2>
          <p>
            Jyotish karmaa Astrology we are dedicated to guiding individuals on their spiritual and life journey through the ancient wisdom of Vedic Astrology. We specialize in multiple streams of astrology including Bhrigu Nandi Nadi (BNN), Lal Kitab, Vastu, Numerology, Gemini Astrology, Prashna, Palmistry, and Vedic Astrology, among others.
          </p>
        </div>
      </div>

      {/* Experience Section */}
      <div className="experience-stats">
        <div className="stat-box">
          <h3>11+</h3>
          <p>Years of Experience</p>
        </div>
        <div className="stat-box">
          <h3>10,000+</h3>
          <p>Lives Touched</p>
        </div>
        <div className="stat-box">
          <h3>4.9★</h3>
          <p>Average Rating</p>
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="mission-vision">
        <div className="mission-box">
          <h3>Our Mission</h3>
        <p>
           The Mission of Jyotish (Vedic Astrology)
          "To synchronize your karma according to your energy and spread the wisdom of astrology from home to home." <br/>

          1. Synchronizing Your Karma According to Your Energy
          Jyotish is not just about prediction — its deeper purpose is alignment and transformation.

        </p>

        <p>
          <strong>Here's what this part of the mission means:</strong> 

        </p>

        <h3>Karma:</h3>
        <p>Karma refers to your past actions that shape your current life experiences — your challenges, strengths, and opportunities.
       </p>
       <h3>Energy (Pranic/Planetary Influence):</h3>
       <p>Every person has a unique energy signature, influenced by the position of planets at birth (natal chart) and ongoing planetary movements (dashas and transits).</p>
        </div>
        <div className="vision-box">
          <h3>Our Vision</h3>
          <p>
           <strong> Synchronizing your karma with your energy means:</strong>
          </p>
          <p>Understanding your karmic blueprint through your birth chart.

              Identifying the planetary influences currently affecting your life.

              Applying personalized remedies (mantra, behavior, donation, etc.) to realign yourself with your higher purpose.

              When this synchronization happens, life flows with more ease, awareness, and spiritual clarity.
          </p>
          <p><strong> It’s like tuning a musical instrument —</strong> when your karma and energy are in harmony, you produce the best melody of life.</p>
          <p><strong> Teaching Astrology from Home to Home</strong> when your karma and energy are in harmony, you produce the best melody of life.</p>
        </div>
      </div>

      {/* Consultation CTA */}
      <div className="consultation-section">
     <div className="consult-text">
              <h2>Book a Consultation Call</h2>

              <p>
                We offer a detailed and personalised consultation session. There is no
                limitation on the number of questions — all aspects of your life will be
                discussed, including career, marriage, finance, health, relationships,
                family and more.
              </p>

              <p>
                Consultations are available in two modes: a normal phone call or a video
                call, based on your comfort.
              </p>

              <p>
                Before scheduling the appointment, we require your birth details so that
                the horoscope can be prepared in advance. 
              </p>

              <p>You can share the following details during the call:</p>


              <ul className="info-list">
                <li>Full Name</li>
                <li>Date of Birth</li>
                <li>Time and Place of Birth</li>
              </ul>

              <div className="animated-arrow-about">
                <FaArrowDown />
              </div>

              <div className="btn-wrapper">
                <a className="call-btn" href="tel:+917905513982">
                  Call Now
                </a>
              </div>
</div>

        <img src={consultImg} alt="Consultation" className="consult-img" />
      </div>

    </div>
  );
}

export default AboutPage;